export default __webpack_public_path__ + "static/firstFloor-a38ebbb106bdc80ed0985336201143aa.png";